// The result choices of the handover, as segmented controls: the same order, labels and colours
// on the desktop and the phone.
import {
  INSPECTION_STATUS_LABELS,
  type InspectionStatus,
  REINSPECTION_RESULT_LABELS,
  type ReinspectionResult,
} from '@sivan/shared';
import type { Segment } from '../ui/ResultSegment';

export type InspectionChoice = Exclude<InspectionStatus, 'unchecked'>;

export const INSPECTION_SEGMENTS: readonly Segment<InspectionChoice>[] = [
  { value: 'ok', label: INSPECTION_STATUS_LABELS.ok, icon: 'check', tone: 'ok' },
  { value: 'defect', label: INSPECTION_STATUS_LABELS.defect, icon: 'x', tone: 'defect' },
  {
    value: 'not_relevant',
    label: INSPECTION_STATUS_LABELS.not_relevant,
    icon: 'minus',
    tone: 'neutral',
  },
];

export const REINSPECTION_SEGMENTS: readonly Segment<ReinspectionResult>[] = [
  { value: 'repaired', label: REINSPECTION_RESULT_LABELS.repaired, icon: 'check', tone: 'ok' },
  {
    value: 'still_defective',
    label: REINSPECTION_RESULT_LABELS.still_defective,
    icon: 'x',
    tone: 'defect',
  },
  { value: 'pending', label: REINSPECTION_RESULT_LABELS.pending, icon: 'clock', tone: 'pending' },
];

/** The chosen value of an inspection result ("טרם נבדק" is no choice). */
export const chosen = (status: InspectionStatus): InspectionChoice | null =>
  status === 'unchecked' ? null : status;
